import React from 'react'

const AppLayout = ({ children }) => {
  return (
    <div
      className='w-screen min-h-screen overflow-x-hidden overflow-y-auto flex flex-col items-center bg-gradient-to-r from-[#CEE1FF] via-[#CEE1FF] to-[#FFFFFF]'
    >
      {children}
    </div>
  )
}

export default AppLayout